"use strict";

exports.__esModule = true;
exports.callRequestSubscription = undefined;

var _templateObject = _taggedTemplateLiteralLoose(["\n\n  subscription callRequest{\n    callRequest{\n      mutation\n      node {\n        id\n        Room{\n          id\n          name\n        }\n        Called{\n          id\n          username\n          fullname\n          image\n        }\n        Caller{\n          id\n          username\n          fullname\n          image\n        }\n        caller_descriptions\n        called_descriptions\n        status\n      }\n    }\n  }\n \n"], ["\n\n  subscription callRequest{\n    callRequest{\n      mutation\n      node {\n        id\n        Room{\n          id\n          name\n        }\n        Called{\n          id\n          username\n          fullname\n          image\n        }\n        Caller{\n          id\n          username\n          fullname\n          image\n        }\n        caller_descriptions\n        called_descriptions\n        status\n      }\n    }\n  }\n \n"]);

var _graphqlTag = require("graphql-tag");

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

var callRequestSubscription = exports.callRequestSubscription = (0, _graphqlTag2.default)(_templateObject);